import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import classNames from 'classnames';
import Button from '@adsk/bim360-matrix-react-button';
import AnimateHeight from '@adsk/bim360-matrix-react-animate-height';
import './_ActivityAttachmentsBlock.scss';
import { withLocale, TSymbolProp } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { ThemeConsumer } from '@adsk/bim360-matrix-react-helpers/es/theme';

export class ActivityAttachmentsBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };
  }

  toggleExpanded() {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  getToggleButtonLabel() {
    return this.state.isExpanded
      ? this.props[TSymbolProp].translate('VIEW_LESS')
      : this.props[TSymbolProp].translate('VIEW_MORE');
  }

  render() {
    const attachmentsArray = this.props.fieldValue;
    let visibleAttachments;
    let hiddenAttachments;
    if (attachmentsArray.length > this.props.numberOfVisibleElements) {
      visibleAttachments = attachmentsArray.slice(0, this.props.numberOfVisibleElements);
      hiddenAttachments = attachmentsArray.slice(
        this.props.numberOfVisibleElements,
        attachmentsArray.length
      );
    } else {
      visibleAttachments = this.props.fieldValue;
    }

    return (
      <ThemeConsumer>
        {({ theme }) => (
          <div
            className={classNames(
              'ActivityAttachmentsBlock',
              this.props.className,
              `ActivityAttachmentsBlock--${theme}`
            )}
          >
            <div className="ActivityAttachmentsBlock__field-name">{this.props.fieldName}</div>
            <div className="ActivityAttachmentsBlock__field-value">
              <div>{visibleAttachments}</div>
              {hiddenAttachments && (
                <div>
                  <AnimateHeight isOpen={this.state.isExpanded} timeout={300} height={'0px'}>
                    <div className="ActivityAttachmentsBlock__hidden-images">
                      <div>{hiddenAttachments}</div>
                    </div>
                  </AnimateHeight>
                  <Button
                    styleType={Button.StyleType.LINK}
                    className="ActivityAttachmentsBlock__button"
                    onClick={() => this.toggleExpanded()}
                  >
                    {this.getToggleButtonLabel()}
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </ThemeConsumer>
    );
  }
}

ActivityAttachmentsBlock.propTypes = {
  /**
   * Class name to append to the container of this component
   */
  className: PropTypes.string,
  /**
   * The title of the changed field
   */
  fieldName: PropTypes.string.isRequired,
  /**
   * A string or React node of the changed field's value
   */
  fieldValue: PropTypes.array.isRequired,
  /**
   * The locale to use for the show/hide button.
   */
  locale: PropTypes.string,
  /**
   * The number of elements to display before adding the "Show more" mechanism
   */
  numberOfVisibleElements: PropTypes.number
};

ActivityAttachmentsBlock.defaultProps = {
  numberOfVisibleElements: 4
};

export default withLocale(
  ActivityAttachmentsBlock,
  ({ locale }) => new MDText(require(`./i18n/${locale}.json`))
);
